export class BaseKeyboardEvent {
    nativeEvent;
    constructor(event) {
        this.nativeEvent = event;
    }
    get capsLock() {
        return this.nativeEvent.getModifierState("CapsLock");
    }
    get code() {
        return this.nativeEvent.code;
    }
    get key() {
        return this.nativeEvent.key;
    }
    get ctrl() {
        return this.nativeEvent.ctrlKey;
    }
    get alt() {
        return this.nativeEvent.altKey;
    }
    get isNumpadKey() {
        return this.nativeEvent.location === KeyboardEvent.DOM_KEY_LOCATION_NUMPAD;
    }
    get isLeftKey() {
        return this.nativeEvent.location === KeyboardEvent.DOM_KEY_LOCATION_LEFT;
    }
    get isRightKey() {
        return this.nativeEvent.location === KeyboardEvent.DOM_KEY_LOCATION_RIGHT;
    }
    get isDigit() {
        return /^\d$/.test(this.key);
    }
    get shift() {
        return this.nativeEvent.getModifierState("Shift");
    }
    get rightShift() {
        return this.isRightKey && this.nativeEvent.shiftKey;
    }
    get meta() {
        return this.nativeEvent.metaKey;
    }
    get esc() {
        return this.key === "Escape";
    }
    get getModifierState() {
        return this.nativeEvent.getModifierState;
    }
}
//# sourceMappingURL=baseKeyboardEvent.js.map